import {Component, Inject} from '@angular/core';
import {ENV_TOKEN, EnvInterface} from 'env-config';
import {ExternalRedirect} from 'auth';

@Component({
  selector: 'app-privacy-policy-component',
  imports: [],
  templateUrl: './privacy-policy-component.html',
  styleUrl: './privacy-policy-component.sass',
})
export class PrivacyPolicyComponent {

  constructor(
    @Inject(ENV_TOKEN)
    protected readonly environment: EnvInterface,
    protected externalRedirect: ExternalRedirect,
  ) {
  }
}
